
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.71 6.29a1 1 0 00-1.42 0l-5 5a1 1 0 000 1.42l5 5a1 1 0 001.639-.325 1 1 0 00-.219-1.095L5.41 12l4.3-4.29a1 1 0 000-1.42zm11 5l-5-5a1.003 1.003 0 10-1.42 1.42l4.3 4.29-4.3 4.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219l5-5a1.002 1.002 0 000-1.42z","fill":"#000"}})])
          )
        }
      }
    